import React, { useState, useEffect } from 'react';
import { X, AlertTriangle } from 'lucide-react';

const PopupBlockerAlert = () => {
  const [isBlocked, setIsBlocked] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Verifica se pop-ups estão bloqueados
    const checkPopupBlocker = () => {
      try {
        // Tenta abrir uma janela popup de teste
        const testWindow = window.open('', '_blank', 'width=1,height=1');
        
        if (!testWindow || testWindow.closed || typeof testWindow.closed === 'undefined') {
          // Pop-up foi bloqueado
          setIsBlocked(true);
        } else {
          // Pop-up não foi bloqueado, fecha a janela de teste
          testWindow.close();
          setIsBlocked(false);
        }
      } catch (e) {
        // Se houver erro, assume que está bloqueado
        setIsBlocked(true);
      }
    };

    // Verifica ao carregar o componente
    checkPopupBlocker();

    // Verifica periodicamente (caso o usuário mude as configurações)
    const interval = setInterval(checkPopupBlocker, 30000); // A cada 30 segundos

    return () => clearInterval(interval);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    // Salva no sessionStorage para não mostrar novamente nesta sessão
    sessionStorage.setItem('popupBlockerAlertDismissed', 'true');
  };

  // Verifica se já foi dispensado nesta sessão
  useEffect(() => {
    const wasDismissed = sessionStorage.getItem('popupBlockerAlertDismissed');
    if (wasDismissed === 'true') {
      setIsDismissed(true);
    }
  }, []);

  if (!isBlocked || isDismissed) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-white shadow-lg">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <AlertTriangle className="w-6 h-6 flex-shrink-0" />
            <div className="flex-1">
              <p className="font-semibold text-sm md:text-base">
                ⚠️ Bloqueador de Pop-ups Detectado
              </p>
              <p className="text-xs md:text-sm mt-1">
                Este sistema utiliza janelas pop-up para funcionar corretamente. 
                Por favor, permita pop-ups para este site nas configurações do seu navegador.
              </p>
              <div className="mt-2 text-xs">
                <strong>Como permitir:</strong>
                <ul className="list-disc list-inside ml-2 mt-1">
                  <li>Chrome/Edge: Clique no ícone 🚫 na barra de endereços → "Sempre permitir pop-ups"</li>
                  <li>Firefox: Clique no ícone 🔒 na barra de endereços → "Desativar bloqueador"</li>
                  <li>Safari: Preferências → Sites → Pop-ups → Permitir para este site</li>
                </ul>
              </div>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="ml-4 p-1 hover:bg-yellow-600 rounded-full transition-colors flex-shrink-0"
            title="Dispensar alerta"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupBlockerAlert;